import axios from 'utils/axios';

export async function fetchProductivityGoalList() {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/productivity-goal/list`);
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            throw e;
        }
        throw new Error('unknown error');
    }
}

export async function postUserProductivityGoal(userId, weekStartDate, goalHours) {
    try {
        const response = await axios.post(`/api/org-id/{orgId}/user/${userId}/productivity-goal`, {
            weekStartDate,
            goalHours
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}
